import { createApp } from 'vue'
import __t from "../../helpers/translate";
import vue_helpers from "../../helpers/check_null";
import VueTheMask from 'vue-the-mask';
import {createBootstrap} from 'bootstrap-vue-next';
import reduction from "./reduction.vue";

import * as ioClient from 'socket.io-client';
const io = ioClient.io || ioClient.default || ioClient;
const socket = io('https://dtenders.imcagro.com.ua', {
    transports: ['websocket'],
    autoConnect: true,
    path: '/socket.io',
});


window.tenderReduction = createApp({
    name : "tenderApp",
    id : "tenderApp",
    components : {
        reduction : reduction,
    }
})
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(VueTheMask)
    .use(v_store);
tenderReduction.config.globalProperties.$socket = socket
tenderReduction.provide('socket', socket);

tenderReduction.mount('#reduction_item');